const getBreadcrumbIndexById = (breadcrumbs, id) => breadcrumbs.findIndex((breadcrumb) => breadcrumb.id === id);
export default getBreadcrumbIndexById;
